import { FileText } from "lucide-react";
import {
  MarkdownTextParamsSchema,
  defaultMarkdownTextParams,
  type MarkdownTextParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { MarkdownTextWidget } from "./Component.js";
import { MarkdownTextExpandedEditor } from "./ExpandedEditor.js";

export const markdownTextDef: WidgetDef<MarkdownTextParams> = {
  kind: "markdownText",
  label: "Text card",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 560, h: 320 },
  defaultParams: defaultMarkdownTextParams,
  Component: MarkdownTextWidget,
  ExpandedComponent: MarkdownTextExpandedEditor,
  expandable: true,
  storage: "sql",
  schema: MarkdownTextParamsSchema,
  accent: "neutral",
  icon: FileText,
  subtitle: "Rendered notes and narratives",
  defaultRoster: false,
  category: "multi",
  layout: { col: "full", row: 0, width: 560, height: 296 },
  askAiPrompt: "Help me review and improve this Markdown text.",
  renderFooter: (data) => ({
    left: `${[...data.markdown].length.toLocaleString()} characters`,
    right: "Markdown",
  }),
};

registerWidget(markdownTextDef);
